export default (siteName) => [
    // 會計科目設定
    {
        path: 'service-fee-statement',
        name: 'service-fee-statement',
        component: () => import('../components/dashboard/ServiceFeeStatement/indexPage.vue'),
        meta: {
            title: `勞報單管理${siteName}`,
            activeMenu: 'service-fee-statement',
        },
    },
    {
        path: 'service-fee-statement/add',
        name: 'add-service-fee-statement',
        component: () => import('../components/dashboard/ServiceFeeStatement/EditPage.vue'),
        meta: {
            title: `新增/編輯勞報單${siteName}`,
            activeMenu: 'service-fee-statement',
        },
    },
    {
        path: 'service-fee-statement/:sno/edit',
        name: 'edit-service-fee-statement',
        component: () => import('../components/dashboard/ServiceFeeStatement/EditPage.vue'),
        meta: {
            title: `新增/編輯勞報單${siteName}`,
            activeMenu: 'service-fee-statement',
        },
    },
    {
        path: 'service-fee-statement/transform',
        name: 'transform-service-fee-statement',
        component: () => import('../components/dashboard/ServiceFeeStatement/TransformPayment/EditPage.vue'),
        meta: {
            title: `勞報單轉送請款單${siteName}`,
            activeMenu: 'service-fee-statement',
        },
    },
    {
        path: 'service-fee-statement/transform/:sno/edit',
        name: 'edit-transform-service-fee-statement',
        component: () => import('../components/dashboard/ServiceFeeStatement/TransformPayment/EditPage.vue'),
        meta: {
            title: `勞報單轉送請款單${siteName}`,
            activeMenu: 'service-fee-statement',
        },
    },
];
